import React, {useState, useEffect} from "react";
import Cookies from 'universal-cookie';
import "./gdpr.scss";
import {graphql, useStaticQuery} from "gatsby";
import { LinkBtn } from '../../elements/LinkBtn/linkBtn';
import { Button } from '../../elements/Button/button';

function Gdpr() {
    const myQuery = useStaticQuery(query);
    const country = myQuery.site.siteMetadata.config.country;
    const static_text = require("../../../content/" + country + "/static-text.json");
    const [needShowGdpr, setNeedShowGdpr] = useState("none");

    useEffect(() => {
        const cookies = new Cookies();
        if (cookies.get('cookie_notice') !== "1") {
            cookies.set('cookie_notice', '1', { path: '/' });
            return (
                setNeedShowGdpr("block")
            );
        }
    }, []);

    return (
        <div className="m-cookie">
            <div className="m-cookie-msg" style={{display: needShowGdpr}}>
                {static_text.gdpr}
                <div className="m-cookie-btn">
                    <LinkBtn strong small lowercase to={"/privacy-policy"} content={static_text.cookie_more_info} />
                    <Button small content={static_text.cookie_accept_button} onClickFunction={()=> setNeedShowGdpr("none")}/>
                </div>
            </div>
        </div>
    );
}

export default Gdpr;

const query = graphql`
  query {
    site {
      siteMetadata {
        config {
          country
        }
      }
    }
  }
`;